import React from "react"
import { Link, graphql } from "gatsby"
import TwoCol from "gatsby-theme-wirehead-bulma/src/twocol"
import Layout from "gatsby-theme-wirehead-bulma/src/layout"
import SEO from "gatsby-theme-wirehead-bulma/src/seo"
import { MDXRenderer } from "gatsby-plugin-mdx"
import RecentImageBlob from "../components/recentimageblob"
import GalleryList from "../components/gallerylist"

export default function PageTemplate({ data, location, pageContext }) {
  const { mdx, allSitePage } = data // data.markdownRemark holds your post data
  const { body } = mdx

  var pages = data.allSitePage.edges.map(article => {
    return (
      <li>
        <Link
          to={article.node.path}
          key={article.node.path}
          className="navbar-item"
        >
          {article.node.context.title}
        </Link>
      </li>
    )
  })
  return (
    <Layout posted={pageContext.date} updated={pageContext.updated}>
      <SEO
        title={pageContext.title}
        pathname={location.pathname}
        description={pageContext.excerpt} />
    <section className="section">
    <TwoCol
      left={
        <div className="content">
          <h1 className="title">{pageContext.title}</h1>
          <img sizes="(min-width: 40em) 60vw, 100vw" alt="" srcSet={data.mdx.image.srcSet}  />
          <MDXRenderer pages={allSitePage}>{body}</MDXRenderer>
        </div>
      }
      right ={
        <div>
        <aside className="menu">
        <p className="menu-label">Galleries</p>
        <GalleryList />
        </aside>
        <div className="sideblock is-clearfix">
        <h3>Recent Images:</h3>
        <RecentImageBlob />
        <br />
        </div>
        <ul className="menu-list">
        {pages}
        </ul>
        </div>
      }
    />
    </section>
    </Layout>
  )
}

export const pageQuery = graphql`
  query($id: String, $path: String) {
    mdx(id: { eq: $id }) {
      body
      id
      frontmatter {
        date(formatString: "MMMM DD, YYYY")
        title
        type
        description
      }
      excerpt(pruneLength: 300)
      image {
        id
        key
        maxSize
        size
        srcSet
        srcPath
        width
        height
        sqSrcSet
        srcSet
      }
    }
    allSitePage(filter: { context: { parent: { eq: $path } } }) {
      edges {
        node {
          context {
            id
            depth
            parent
            title
          }
          path
        }
      }
    }
  }
`
